import React, { ReactElement } from 'react'
import { EntryThumbnailListWithField } from './EntryThumbnailList'
import { Routes, Route } from 'react-router-dom'
import EntryWrite from '../Write/Write'
import VoiceContextProvider from '../contexts/VoiceContext'

// Paths are relative to the mounting route (e.g. /entries/*); the list only matches under /entries.
const EntryPage = (): ReactElement =>
    <EntryPageContents />

const EntryPageContents = (): ReactElement =>
    <div className="page entry-page">
        <Routes>
            <Route path="with/:field/:comparison/:value" element={ <EntryThumbnailListWithField /> } />
            <Route path="by/:field/:comparison/:value" element={ <EntryThumbnailListWithField /> } />
            <Route path="with/:field/:value" element={ <EntryThumbnailListWithField /> } />
            <Route path="by/:field/:value" element={ <EntryThumbnailListWithField /> } />
            <Route path="by/:field" element={ <EntryThumbnailListWithField /> } />
            <Route
                path="*"
                element={
                    <VoiceContextProvider>
                        <EntryWrite />
                    </VoiceContextProvider>
                } />
        </Routes>
    </div>

export default EntryPage
